import { OnDestroy } from '@angular/core';
import { AfterContentInit, ContentChildren, Directive, QueryList } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../components/confirm/confirm.component';
import { IConfirm } from '../interfaces/confirm';
import { MiniGuidanceService } from '../services/common/mini-guidance.service';
import { MiniGuideDirective } from './mini-guide.directive';

@Directive({
  selector: '[appMiniGuideParent]'
})
export class MiniGuideParentDirective implements AfterContentInit, OnDestroy {

  private currentIndex: number = 0;
  
  @ContentChildren(MiniGuideDirective) childrenQueryList: QueryList<MiniGuideDirective>;

  private children: MiniGuideDirective[] = [];

  nextGuide$: Subscription;

  confirmDialog: MatDialogRef<ConfirmComponent>;


  constructor(
    private miniGuideService: MiniGuidanceService,
    private dialog: MatDialog
    ) {
    }

  ngAfterContentInit(): void {
    this.children = this.childrenQueryList.toArray();


    let confirm: IConfirm = {
      accept: true,
      message: 'کاربر گرامی، ایا تمایل دارید راهنمای این بخش را مشاهده کنید؟',
      alert: null,
      yesLabel: 'بله',
      noLabel: 'خیر'
    };
    this.confirmDialog = this.dialog
      .open(ConfirmComponent, {
        width: "300px",
        data: confirm
      });

      this.confirmDialog.afterClosed()
      .subscribe(res => {
        if (res) {
          this.showFirstGuide();
        }
      });

    this.nextGuide$ = this.miniGuideService.onNextGuideReady.subscribe((isNext: boolean) => {
      if(isNext)
      this.showNextGuide();

      if(!isNext)
      this.showPrevGuide();
    })
  }


  showFirstGuide()
  {
    this.children[this.currentIndex].showGuide(true, false);
  }

  showNextGuide()
  {
    this.children[this.currentIndex].clearStyles();
    this.currentIndex++;

    if(this.children[this.currentIndex])
      this.children[this.currentIndex].showGuide(this.currentIndex == 0, this.currentIndex == this.children.length - 1);
  }

  showPrevGuide()
  {
    this.children[this.currentIndex].clearStyles();
    this.currentIndex--;

    if(this.children[this.currentIndex])
      this.children[this.currentIndex].showGuide(this.currentIndex == 0, this.currentIndex == this.children.length - 1);
  }

  ngOnDestroy()
  {
    this.nextGuide$.unsubscribe();
    this.miniGuideService.forceCloseCurrentGuide();

    if(this.confirmDialog)
    {
      this.confirmDialog.close();
    }
  }



}
